import appConfig from '@/config/appConfig.typed';
import {LOGIN_TYPE_CODE, LoginTypeCode, OTP_TYPE_CODE, OtpTypeCode} from '@/consts/loginTypes';
import arrayUtils from '@/utils/arrayUtils';

const DEFAULT_LOGIN_TYPE: LoginTypeCode = LOGIN_TYPE_CODE.LOGIN_PASSWORD;
const DEFAULT_OTP_TYPE: OtpTypeCode = OTP_TYPE_CODE.PHONE;

interface LoginConfig {
    loginTypes: LoginTypeCode[];
    otpChannels: OtpTypeCode[];
}

interface LoginConfigService {
    getLoginConfig: () => LoginConfig;
}

const getLoginConfig = (): LoginConfig => {
    const loginSettings = appConfig.getLoginSettings();
    const otpSettings = appConfig.getOtpSettings();

    const sortedLoginTypes = arrayUtils.sortArrayWithOrderField(loginSettings?.loginTypes);
    const sortedOtpTypes = arrayUtils.sortArrayWithOrderField(otpSettings?.otpTypes);

    const loginTypesFromSettings: LoginTypeCode[] =
        sortedLoginTypes?.map(({type}: {type: LoginTypeCode}) => type) || [];
    const otpChannelsFromSettings: OtpTypeCode[] = sortedOtpTypes?.map(({type}: {type: OtpTypeCode}) => type) || [];

    const loginTypes: LoginTypeCode[] = loginTypesFromSettings.length ? loginTypesFromSettings : [DEFAULT_LOGIN_TYPE];
    const otpChannels: OtpTypeCode[] = otpChannelsFromSettings.length ? otpChannelsFromSettings : [DEFAULT_OTP_TYPE];

    return {
        loginTypes,
        otpChannels,
    };
};

const loginConfigService: LoginConfigService = {getLoginConfig};

export default loginConfigService;
